
Greenmile.RouteProgress = Greenmile.RouteProgress || {};

Greenmile.RouteProgress.Updater = {

    checkIfRouteProgressExist: function () {

        var routeProgressTab = document.getElementById('RouteProgress');

        if (routeProgressTab) {
            return true;
        }

        clearInterval(Greenmile.RouteProgress.Updater.scheduler);

        return false;

    },

    runScheduler: function () {

        if (!Greenmile.RouteProgress.Updater.scheduler) {
            if (Greenmile.RouteProgress.Updater.checkIfRouteProgressExist()) {
                Greenmile.RouteProgress.Updater.scheduler = setInterval(function () {
                    if (Greenmile.RouteProgress.Updater.checkIfRouteProgressExist()) {

                        var currentTab = Monet.Utils.GetTabName();

                        if (currentTab === "RouteProgress" && App.Forms.RouteProgress.canUpdate && App.Forms.RouteProgress.controlUpdater.getPages().length) {

                            var progress = new App.Routers.RouteProgress();
                            progress.requestDataToUpdate();
                            console.log('RouteProgress updated at ' + new Date());
                        }

                    }
                }, 60000);
            }

        } else {
            if (!Greenmile.RouteProgress.Updater.checkIfRouteProgressExist()) {
                clearInterval(Greenmile.RouteProgress.Updater.scheduler);
            }
        }

    },

    processUpdate: function () {

        App.Routers.RouteProgress.updateGrid();

    }


};